import { Chip, ChipSizeEnum } from "../../../components/core/Chip/Chip";
import { Loader } from "../../../components/core/Loader/Loader";
import { PercentageChip } from "../../../components/core/PercentageChip/PercentageChip";
import { ALL_PLURAL_LABEL } from "../../../constants/Dictionary";
import { TypeMatrixEnum } from "../../../constants/PotentialMatrixConstants";
import { StyledInternalGradesChipsContainer } from "./InternalGradesChips.style";
import { InternalGradeStats } from "../../../types/api/potentialMatrix.type";
import { getInternalGradeMetaFromLabel } from "../../../utils/potentialMatrixGrade.utils";

type InternalGradeChipsProps = {
  onChange: (grades: string[]) => void;
  value: string[];
  type: TypeMatrixEnum;
  visible: boolean;
  potentialMatrixStatsData: InternalGradeStats[];
  loadingPotentialMatrixStats?: boolean;
  alignFiltersToGrid?: boolean;
};

export const InternalGradeChips = ({
  onChange,
  value,
  type,
  visible,
  potentialMatrixStatsData,
  loadingPotentialMatrixStats,
  alignFiltersToGrid = false,
}: InternalGradeChipsProps) => {
  const onSelectInternalGrade = (grade: string) => {
    let updatedGrades = [];
    if (grade === "all") {
      updatedGrades = ["all"];
    } else {
      updatedGrades = [...value];
      const index = updatedGrades.indexOf(grade);
      if (index > -1) {
        updatedGrades.splice(index, 1);
        if (updatedGrades.length === 0) {
          updatedGrades.push("all");
        }
      } else {
        updatedGrades.push(grade);
        const allIndex = updatedGrades.indexOf("all");
        if (allIndex > -1) {
          updatedGrades.splice(allIndex, 1);
        }
      }
    }

    onChange(updatedGrades);
  };

  const withPercentage = type === TypeMatrixEnum.FINAL_EVALUATION;

  if (!visible) {
    return null;
  }

  return (
    <StyledInternalGradesChipsContainer
      $alignFiltersToGrid={alignFiltersToGrid}
    >
      <Chip
        option={{ label: ALL_PLURAL_LABEL, value: "all" }}
        size={ChipSizeEnum.BIG}
        selectedChip={value.includes("all")}
        onSelectChip={onSelectInternalGrade}
      />
      {loadingPotentialMatrixStats ? (
        <div className="internal-grades-chip-loading-container">
          <Loader loading={true} size={16} />
        </div>
      ) : null}

      {!loadingPotentialMatrixStats &&
        potentialMatrixStatsData?.map((grade) => {
          const gradeMeta = getInternalGradeMetaFromLabel(
            grade.internalGradeEnum,
          );
          return (
            <PercentageChip
              key={grade.internalGradeEnum}
              option={{
                value: grade.internalGradeEnum,
                label: gradeMeta?.label ?? grade.internalGradeEnum,
                percentage: withPercentage ? grade.percentage : undefined,
              }}
              color={gradeMeta?.color}
              selectedChip={value.includes(grade.internalGradeEnum)}
              onSelectChip={onSelectInternalGrade}
            />
          );
        })}
    </StyledInternalGradesChipsContainer>
  );
};
